__turbopack_context__.v({
  "border-default": "tab-button-module-scss-module__KSJVCW__border-default",
  "button-badge": "tab-button-module-scss-module__KSJVCW__button-badge",
  "button-description": "tab-button-module-scss-module__KSJVCW__button-description",
  "button-icon": "tab-button-module-scss-module__KSJVCW__button-icon",
  "button-middle": "tab-button-module-scss-module__KSJVCW__button-middle",
  "button-title": "tab-button-module-scss-module__KSJVCW__button-title",
  "contained": "tab-button-module-scss-module__KSJVCW__contained",
  "content": "tab-button-module-scss-module__KSJVCW__content",
  "disabled": "tab-button-module-scss-module__KSJVCW__disabled",
  "fill": "tab-button-module-scss-module__KSJVCW__fill",
  "outline": "tab-button-module-scss-module__KSJVCW__outline",
  "outline-round": "tab-button-module-scss-module__KSJVCW__outline-round",
  "primary": "tab-button-module-scss-module__KSJVCW__primary",
  "round": "tab-button-module-scss-module__KSJVCW__round",
  "secondary": "tab-button-module-scss-module__KSJVCW__secondary",
  "selected": "tab-button-module-scss-module__KSJVCW__selected",
  "side-icon": "tab-button-module-scss-module__KSJVCW__side-icon",
  "tab-button": "tab-button-module-scss-module__KSJVCW__tab-button",
  "top-icon": "tab-button-module-scss-module__KSJVCW__top-icon",
  "underline": "tab-button-module-scss-module__KSJVCW__underline",
  "without-content-min-width": "tab-button-module-scss-module__KSJVCW__without-content-min-width",
});
